module.exports = __webpack_public_path__ + "img/horizontal_7_1_pp1_0.24e2feff.png";